var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.937336,0.141293l-17.921325,0c-1.544034,0 -2.800207,1.256173 -2.800207,2.800207l0,17.921325c0,1.544034 1.256173,2.800207 2.800207,2.800207l17.921325,0c1.544034,0 2.800207,-1.256173 2.800207,-2.800207l0,-17.921325c0,-1.544034 -1.256173,-2.800207 -2.800207,-2.800207zm-2.236805,10.261639c-0.127129,0.011761 -0.255939,0.019601 -0.386429,0.019601c-1.468989,0 -2.759884,-0.755496 -3.5109,-1.89742c0,2.995662 0,6.404074 0,6.461198c0,2.637235 -2.138238,4.775473 -4.775473,4.775473s-4.775473,-2.138238 -4.775473,-4.775473s2.138238,-4.775473 4.775473,-4.775473c0.099687,0 0.197135,0.008961 0.295142,0.015121l0,2.353294c-0.098007,-0.011761 -0.194334,-0.029682 -0.295142,-0.029682c-1.34634,0 -2.4373,1.090961 -2.4373,2.4373s1.090961,2.4373 2.4373,2.4373s2.535308,-1.060718 2.535308,-2.407058c0,-0.053204 0.023522,-10.973452 0.023522,-10.973452l2.249126,0c0.211696,2.011109 1.835256,3.598266 3.864846,3.743877l0,2.615393z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.9786ec5d.svg";
export { ForwardRef as ReactComponent };